import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-th',
  templateUrl: './th.component.html',
  styleUrls: ['./th.component.scss']
})
export class ThComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
